export const initialStates = {
  threads: [],
  messages: [],
};
